import { addDays } from 'date-fns'
import { BookingAvailabilities } from './types'
import { combineDateAndTime } from './utils/utils'
import { BookingPeriods } from './Popover/enums'
import { Time } from './Shared/enums'
import { SelectOption } from '../../services/dashboardService'

// eslint-disable-next-line no-shadow
export enum BookingAvailabilityColors {
  NOT_ACTIVE = '#dddddd',
  AVAILABLE = '#70BA82',
  OWN_BOOKING = '#20c5a1',
  NOT_AVAILABLE = '#BA7070',
  NOT_AVAILABLE_BACKGROUND = 'rgba(186, 112, 112, 0.1)',
  PARTIALLY_AVAILABLE = '#DB8733',
  PARTIALLY_AVAILABLE_BACKGROUND = 'rgba(219, 135, 51, 0.1)',
  AVAILABLE_TEXT = '#60D08E',
  AVAILABLE_BACKGROUND = 'rgba(96, 208, 142, 0.1)'
}

// eslint-disable-next-line no-shadow
export const BookingAvailability: BookingAvailabilities = {
  NO_AVAILABILITY: {
    text: 'Fully Booked',
    color: BookingAvailabilityColors.NOT_AVAILABLE,
    chipTextColor: BookingAvailabilityColors.NOT_AVAILABLE,
    backgroundColor: BookingAvailabilityColors.NOT_AVAILABLE_BACKGROUND
  },
  PARTIAL_AVAILABILITY: {
    text: 'Limited',
    color: BookingAvailabilityColors.PARTIALLY_AVAILABLE,
    chipTextColor: BookingAvailabilityColors.PARTIALLY_AVAILABLE,
    backgroundColor: BookingAvailabilityColors.PARTIALLY_AVAILABLE_BACKGROUND
  },
  AVAILABLE: {
    text: 'Available',
    color: BookingAvailabilityColors.AVAILABLE,
    chipTextColor: BookingAvailabilityColors.AVAILABLE_TEXT,
    backgroundColor:  BookingAvailabilityColors.AVAILABLE_BACKGROUND,
  },
  OWN_BOOKING: { text: 'Own Booking', color: BookingAvailabilityColors.OWN_BOOKING },
  NOT_ACTIVE: { text: 'Not Active', color: BookingAvailabilityColors.NOT_ACTIVE },
}

// eslint-disable-next-line no-shadow
export enum BookingDateRange {
  FROM = 0,
  TO = 1,
}

// eslint-disable-next-line no-shadow
export enum ButtonLabelType {
  BOOK_NOW = 'Book Now',
  CANCEL_BOOKING = 'Cancel Booking',
  SELECT = 'Select',
}

// eslint-disable-next-line no-shadow
export enum ManagerBookingOptions {
  MYSELF = 1,
  EMPLOYEE = 2,
  VISITOR = 3,
}

export const BOOKING_FOR_OPTIONS: SelectOption[] = [
  { value: ManagerBookingOptions.MYSELF, displayValue: 'Myself' },
  { value: ManagerBookingOptions.EMPLOYEE, displayValue: 'Employee' },
  { value: ManagerBookingOptions.VISITOR, displayValue: 'Visitor' },
]

// eslint-disable-next-line no-shadow
export enum MobileOrientationPopOverOptions {
  NOT_MOBILE = 2,
  MOBILE_PORTRAIT = 3,
  MOBILE_LANDSCAPE = 4,
}

export const FIRST_FLOORPLAN_IN_ARRAY = 0
export const FIRST_ZONE_IN_ARRAY = 0

export const FULL_DAY_RANGE = {
  from: combineDateAndTime(new Date(), '00:00:00'),
  to: combineDateAndTime(addDays(new Date(), 1), '00:00:00'),
}
export const DEFAULT_SHIFT_RANGE = {
  from: combineDateAndTime(new Date(), '09:00:00'),
  to: combineDateAndTime(new Date(), '17:30:00'),
}

export const BOOKING_SLOT_INCREMENT = 5

export const BOOKING_LENGTH_OPTION_MAP: { [key in BookingPeriods]: { from: Time, to: Time, text: string } } = {
  [BookingPeriods.FULL_DAY]: {
    from: Time.MIDNIGHT,
    to: Time.MIDNIGHT_MINUS_ONE_SECOND,
    text: 'Full Day'
  },
  [BookingPeriods.HALF_DAY_FIRST_HALF]: {
    from: Time.MIDNIGHT,
    to:Time.MIDDAY_MINUS_ONE_SECOND,
    text: 'First Half'
  },
  [BookingPeriods.HALF_DAY_SECOND_HALF]: {
    from: Time.MIDDAY,
    to: Time.MIDNIGHT_MINUS_ONE_SECOND,
    text: 'Second Half'
  },
  [BookingPeriods.CUSTOM_TIME_SLOT]: {
    from: Time.DEFAULT_SHIFT_START,
    to: Time.DEFAULT_SHIFT_END,
    text: 'Custom'
  }
}